import { getExternalNavComponentDimensionAction } from '../actions';
import { isWindowTopLevel } from './isWindowTopLevel';
export function updateExternalnavComponentDimension(compName, dimensions, dispatch) {
  if (!isWindowTopLevel()) {
    if (compName === 'Banners') {
      const payload = {
        compName,
        dimensions: {
          height: 0
        }
      };
      const action = getExternalNavComponentDimensionAction(payload);
      dispatch(action);
    }
    return;
  }
  const payload = {
    compName,
    dimensions
  };
  const action = getExternalNavComponentDimensionAction(payload);
  dispatch(action);
}